<template>
  <ReviewItemDetailsLayout :review-item="guidance" :expansion-panel="expansionPanel">
    <template #subtitle>
      <p v-if="guidance.metadata.reference" class="text-sm text-neutral-text-subtitle">
        {{ guidance.metadata.reference }}
      </p>
    </template>
  </ReviewItemDetailsLayout>
</template>

<script setup lang="ts">
import ReviewItemDetailsLayout from "./ReviewItemDetailsLayout.vue";
import { Guidance } from "@core/domain/models/guidance.model";
import useExpansionPanel from "@app/composables/use-expansion-panel";

defineProps<{
  guidance: Guidance;
  expansionPanel: ReturnType<typeof useExpansionPanel>;
}>();
</script>
